import { render, staticRenderFns } from "./stockSupplierMatrix.vue?vue&type=template&id=29e46908&"
import script from "./stockSupplierMatrix.vue?vue&type=script&lang=js&"
export * from "./stockSupplierMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports